import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import Input from 'component/utils/Input'
import InputFile from 'component/utils/InputFile'
import TextArea from 'component/utils/TextArea'
import DatePicker from 'component/utils/DatePicker'
import ViewModal from 'component/video/VideosModal'
import ProgressBar from 'component/utils/ProgressBar'
import firebase from 'utils/Firebase'

const VIEW = 'VIDEOS_VIEW'

class VideosEditForm extends Component {
  state = {
    modal: false,
    dtStart: null,
    dtEnd: null,
    uploading: false,
    progress: false,
    dsFileName: '',
    videoForModal: {},
  }

  closeModal = () => {
    this.setState({ modal: false })
  }

  openModal = () => {
    const { values } = this.props

    const video = {
      ...values,
      videoUrl: values.dsFile,
      videoTitle: values.nmVideo,
      videoDescription: values.dsVideo,
    }

    this.setState({ modal: true, videoForModal: video })
    this.beforeSubmit()
  }

  renderModal = () => {
    const { modal, videoForModal } = this.state
    const { translate } = this.props

    /* istanbul ignore else */
    if (!modal) {
      return
    }

    const props = {
      translate,
      modalType: VIEW,
      isNew: true,
      video: videoForModal,
      closeModal: this.closeModal,
    }

    return <ViewModal {...props} />
  }

  beforeSubmit = () => {
    const { values, setValueToField } = this.props
    const { dsBranch } = this.state

    /* istanbul ignore else */
    if (values.idBranch) {
      setValueToField('dsbranch', dsBranch)
    }
    // Sets to 'not updated'
    values.inUpdate = 0
  }

  handleSubmit = (event) => {
    event.preventDefault()

    const { values, onSubmit, auth } = this.props

    const data = { ...values, cdLdap: auth.user.username }

    onSubmit(data, this.clearFields)

    this.closeModal()
  }

  clearFields = () => {
    const { fields, invertStates, values } = this.props

    fields.dsFile.input.value = null
    fields.nmVideo.input.value = ''
    fields.dsVideo.input.value = ''
    fields.dtStart.input.value = ''
    fields.dtEnd.input.value = ''

    fields.dsFile.error = ''
    fields.nmVideo.error = ''
    fields.dsVideo.error = ''
    fields.dtStart.error = ''
    fields.dtEnd.error = ''

    values.dsFile = null
    values.nmVideo = ''
    values.dsVideo = ''
    values.dtStart = ''
    values.dtEnd = ''

    this.setState({
      uploading: false,
      progress: 0,
      dsFileName: '',
      dtStart: '',
      dtEnd: '',
    })

    fields.dsFile.input.ref = undefined

    invertStates()
  }

  handleFilesChange = async (event) => {
    const inputFiles = event.target.files

    /* istanbul ignore else */
    if (inputFiles && inputFiles[0]) {
      this.uploadToFirebase(inputFiles[0])
    }
  }

  isOutsideRange = () => false

  handleChangeDate = (date, field) => {
    this.setState({ [field]: date })

    const { setValueToField } = this.props
    setValueToField(field, date.format('DD/MM/YYYY'))
  }

  uploadToFirebase = (file) => {
    this.setState({
      dsFileName: file.name,
      progress: 0,
      uploading: true,
    })

    // Creates a root reference
    const storageRef = firebase.storage().ref()

    const fileName = new Date().valueOf() + file.name

    // Uploads file
    const uploadTask = storageRef.child('videos').child(fileName).put(file)

    // Listens for state changes, errors, and completion of the upload
    uploadTask.on(
      firebase.storage.TaskEvent.STATE_CHANGED,
      this.firebaseUpdateProgress,
      this.firebaseUploadError,
      () => {
        // Upload completed successfully, now we can get the download URL
        uploadTask.snapshot.ref.getDownloadURL().then(this.updateFileUrl)
      }
    )
  }

  firebaseUpdateProgress = (snapshot) => {
    // Gets task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
    this.setState({ progress })
  }

  firebaseUploadError = (error) => {
    this.setState({ uploading: false, progress: 0 })
    console.error(error)
  }

  updateFileUrl = (downloadURL) => {
    const { setValueToField } = this.props
    setValueToField('dsFile', downloadURL)

    this.setState({ uploading: false, progress: 0 })
  }

  render() {
    const { translate, fields, values } = this.props

    const { uploading, progress } = this.state

    const inputFileDisabled = values.dsFile || uploading

    return (
      <div>
        <form className='VideoCreateForm'>
          <fieldset>
            <Row>
              <Col xs={12}>
                <legend>{translate('videos.new-video')}</legend>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12}>
                <Field
                  {...fields.dsFile}
                  error={translate(fields.dsFile.error)}
                >
                  {!inputFileDisabled && (
                    <InputFile
                      id='dsFile'
                      disabled={inputFileDisabled}
                      className='margin-vertical-small'
                      translate={translate}
                      setInputRef={this.setInputRef}
                      sideText={translate('videos.dsFile')}
                      {...fields.dsFile.input}
                      onChange={this.handleFilesChange}
                    />
                  )}

                  {uploading && <ProgressBar percent={progress} />}

                  {values.dsFile && (
                    <Input
                      id='dsPlaceholder'
                      disabled
                      className='margin-vertical-small'
                      translate={translate}
                      {...fields.dsPlaceholder.input}
                      value={this.state.dsFileName}
                    />
                  )}
                </Field>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12}>
                <Field
                  {...fields.nmVideo}
                  error={translate(fields.nmVideo.error)}
                >
                  <Input
                    id='nmVideo'
                    {...fields.nmVideo.input}
                    maxLength={40}
                    label={translate('videos.nmVideo')}
                  />
                </Field>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={12}>
                <Field
                  {...fields.dsVideo}
                  error={translate(fields.dsVideo.error)}
                >
                  <TextArea
                    type='textarea'
                    id='dsVideo'
                    {...fields.dsVideo.input}
                    maxLength={150}
                    rows={3}
                    label={translate('videos.dsVideo')}
                    autoExpandable
                  />
                </Field>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <span className='gray-label'>{translate('videos.period')}</span>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={6}>
                <Field
                  {...fields.dtStart}
                  error={translate(fields.dtStart.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    date={this.state.dtStart}
                    onDateChange={(date) =>
                      this.handleChangeDate(date, 'dtStart')
                    }
                    placeholder={translate('videos.dtStart')}
                    isOutsideRange
                  />
                </Field>
              </Col>

              <Col xs={12} md={6}>
                <Field
                  {...fields.dtEnd}
                  error={translate(fields.dtEnd.error)}
                  glyph='glyph glyph-calendar'
                >
                  <DatePicker
                    date={this.state.dtEnd}
                    onDateChange={(date) =>
                      this.handleChangeDate(date, 'dtEnd')
                    }
                    placeholder={translate('videos.dtEnd')}
                    isOutsideRange
                  />
                </Field>
              </Col>
            </Row>
          </fieldset>

          <Row className='margin-top-double margin-bottom'>
            <Col xs={6} md={6}>
              <button
                role='button'
                type='button'
                onClick={this.clearFields}
                className='button-hollow button-hollow-danger button-full align-center'
              >
                {translate('cancel_button_label')}
              </button>
            </Col>

            <Col xs={6} md={6}>
              <button
                role='button'
                type='button'
                onClick={this.openModal}
                disabled={!values.dsFile}
                className='button button-primary button-full'
              >
                {translate('videos.view')}
              </button>
            </Col>
          </Row>

          <Row className='margin-bottom'>
            <Col xs={12} md={12}>
              <button
                role='button'
                type='button'
                disabled={!values.dsFile}
                onClick={this.handleSubmit}
                className='button button-primary button-full'
              >
                {translate('save_button_label')}
              </button>
            </Col>
          </Row>
        </form>
        {this.renderModal()}
      </div>
    )
  }
}

VideosEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  invertStates: PropTypes.func.isRequired,
  video: PropTypes.object,
  setValueToField: PropTypes.func.isRequired,
}

const fields = [
  'dsVideo',
  'nmVideo',
  'dtStart',
  'dtEnd',
  'dsFile',
  'dsPlaceholder',
]

export default Form({ fields })(VideosEditForm)

export { VideosEditForm }
